import type { FunctionComponent } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { JobAdsEmptyStates } from "@/modules/companies/client/components/JobAdsEmptyStates/JobAdsEmptyStates"
import { JobAdsPaginationWrapper } from "@/modules/companies/client/components/JobAdsPaginationWrapper"
import { JobAdsResults } from "@/modules/companies/client/components/JobAdsResults/JobAdsResults"
import { JobAdsTitle } from "@/modules/companies/client/components/JobAdsTitle/JobAdsTitle"
import { useCompanyAnalyticsData } from "@/modules/companies/client/components/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { ResultsLoading as JobAdsLoading } from "@/modules/jobAds/client/components/ResultsLoading/ResultsLoading"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { MAX_JOB_ADS } from "@/modules/jobSearch/constants/response"

import styles from "./JobAdsWrapper.module.css"

export const JobAdsWrapper: FunctionComponent = () => {
  const { dataJobAds, isSuccessJobAds, isLoadingJobAds } = useJobAdsFromAlgolia()
  const { dataCompany } = useCompanyFetch()
  const { hasEnoughData } = useCompanyAnalyticsData()

  if (!dataCompany) return null

  const showJobAdsLoading = isLoadingJobAds
  const showJobAdsResults = !showJobAdsLoading && isSuccessJobAds && dataJobAds && dataJobAds.jobAds.length > 0
  const showJobAdsPagination = isSuccessJobAds && dataJobAds && dataJobAds.totalSize > MAX_JOB_ADS
  const showJobAdsEmptyStates = !isLoadingJobAds && isSuccessJobAds && dataJobAds && dataJobAds.jobAds.length === 0

  return (
    <Layout isSmall hasBottomPadding={hasEnoughData} colorBlock={LAYOUT_COLOR_BLOCK.WHITE} className={styles.main}>
      <Layout.Column>
        <JobAdsTitle />
        {showJobAdsLoading && <JobAdsLoading />}
        {showJobAdsResults && (
          <JobAdsResults jobAds={dataJobAds.jobAds} company={{ id: dataCompany.id, name: dataCompany.page.name }} />
        )}
        {showJobAdsPagination && <JobAdsPaginationWrapper />}
        {showJobAdsEmptyStates && <JobAdsEmptyStates />}
      </Layout.Column>
    </Layout>
  )
}
